import { t } from 'i18next';
import { PITCH_TYPE_OPTIONS } from 'lib_ts/enums/pitches.enums';

export const PITCH_TYPE_FILTER_OPTIONS = PITCH_TYPE_OPTIONS.map((option) => ({
  ...option,
  label: `${t(option.label)} (${option.value})`,
}));
